export const GET_COURIER_SCHEDULE_BY_ID = Symbol('GET_COURIER_SCHEDULE_BY_ID');
export const GET_COURIER_SCHEDULE_BY_ID_REQUEST = Symbol('GET_COURIER_SCHEDULE_BY_ID_REQUEST');
export const GET_COURIER_SCHEDULE_BY_ID_SUCCESS = Symbol('GET_COURIER_SCHEDULE_BY_ID_SUCCESS');
export const GET_COURIER_SCHEDULE_BY_ID_ERROR = Symbol('GET_COURIER_SCHEDULE_BY_ID_ERROR');

